import { Axios } from "./request";

const API_URL = "usersapi/v1/users/";

export const USERS_API = {
  Register: (body) => {
    return Axios.post(`${API_URL}Register`, body, { withToken: false });
  },
  SendVerification: (username, isByEmail, captchaToken) => {
    return Axios.post(
      `${API_URL}SendVerification?username=${username}&isByEmail=${isByEmail}&captchaToken=${captchaToken}`,
      {},
      { withToken: false }
    );
  },
  ConfirmEmail: (token, email) => {
    return Axios.post(
      `${API_URL}ConfirmEmail/?token=${token}&email=${email}`,
      {},
      { withToken: false }
    );
  },
  ConfirmPhoneNumber: (token, phoneNumber) => {
    return Axios.post(
      `${API_URL}ConfirmPhoneNumber/?token=${token}&phoneNumber=${phoneNumber}`,
      {},
      { withToken: false }
    );
  },
  ForgotPassword: (body) => {
    return Axios.post(`${API_URL}ForgotPassword`, body, { withToken: false });
  },
  ResetPassword: (body) => {
    return Axios.post(`${API_URL}ResetPassword`, body, { withToken: false });
  },
  ForgotPasswordSendVerification: (username, isByEmail) => {
    return Axios.post(
      `${API_URL}ForgotPasswordSendVerification/?username=${username}&isByEmail=${isByEmail}`,
      {},
      { withToken: false }
    );
  },
  GetUserInfo: () => {
    return Axios.get(`${API_URL}GetUserInfo`);
  },
  GenderDetermination: (username, gender) => {
    return Axios.post(
      `${API_URL}GenderDetermination?username=${username}&gender=${gender}`,
      {},
      { withToken: false }
    );
  },
  LogOut: (refresh) => {
    return Axios.post(
      `${API_URL}LogOut`,
      {},
      {
        headers: {
          RefreshToken: refresh,
        },
      }
    );
  },
};
